require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./study-chrysalis-solmotive-team-as-a-service-and-micro-service-platform.json") })
        }
      }, "path---study-chrysalis-solmotive-team-as-a-service-and-micro-service-platform");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---study-chrysalis-solmotive-team-as-a-service-and-micro-service-platform!./.cache/json/study-chrysalis-solmotive-team-as-a-service-and-micro-service-platform.json
// module id = 923
// module chunks = 231608221292675